import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Heading from './heading/Heading';
import { getFabrics } from '../reducers/fabrics';
import ContentWrapper from './styles/ContentWrapper';
import Link from './Link';
import List from './List';
import { getMessage } from '../reducers/i18n';
import Manufacturer from './common/Manufacturer';

const Fabrics = ({ fabrics, fabricInfoPrefix }) => {
    const buildSpec = fabricInfo => {
        const items = [];
        Object.keys(fabricInfo.specification.content).map((label, index) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-label'>{label}: </span>
                <span className='stolo-list-item-value'>
                    {fabricInfo.specification.content[label]}
                </span>
            </li>);
        });
        return items;
    };

    const buildCareInstructions = fabricInfo => {
        const items = [];
        fabricInfo['care-instructions'].content.map((value, index) => {
            items.push(<li className='stolo-list-item' key={index}>
                <span className='stolo-list-item-value'>{value}</span>
            </li>);
        });
        return items;
    };

    const StyledText = styled.p`
        max-width: ${props => props.theme.space[23]};
        line-height: 1.31;
        margin-bottom: ${props => props.theme.space[7]};
    `;

    const buildFabricInfo = () => Object.keys(fabrics).map(fabricId => {
        const fabricInfo = fabrics[fabricId];
        return (
            <div id={fabricId}>
                <Heading
                    level={1}
                    text={[fabricInfoPrefix, ' ', fabricInfo.title]}
                />
                <StyledText>
                    {fabricInfo.description.content}
                </StyledText>
                <img
                    src={fabricInfo.description.img}
                    alt={fabricInfo.title}
                />
                <Heading level={2} text={fabricInfo.usage.label} />
                <StyledText>
                    {fabricInfo.usage.content}
                </StyledText>
                <img
                    src={fabricInfo.usage.img}
                    alt={fabricInfo.usage.label}
                />
                <Heading
                    level={2}
                    text={fabricInfo.specification.label}
                />
                <StyledText>
                    <ul>
                        {buildSpec(fabricInfo)}
                    </ul>
                </StyledText>
                <Heading
                    level={2}
                    text={fabricInfo['care-instructions'].label}
                />
                <StyledText>
                    <ul>
                        {buildCareInstructions(fabricInfo)}
                    </ul>
                    <img
                        src='https://d2k02hhj0n6fcf.cloudfront.net/images/care-1-2.png'
                        alt={fabricInfo['care-instructions'].label}
                    />
                </StyledText>
                <Manufacturer />
            </div>
        );
    });

    const buildIndex = () => Object.keys(fabrics).map(fabricId => {
        const fabricInfo = fabrics[fabricId];
        return (
            <Link to={`#${fabricId}`}>
                {fabricInfo.title}
            </Link>
        );
    });

    return (
        <article role='article' about='/faq/fabrics' typeof='schema:WebPage'>
            <ContentWrapper>
                <List items={buildIndex()} />
                {buildFabricInfo()}
            </ContentWrapper>
        </article>
    );
};

const makeMapStateToProps = initialState => {
    const fabrics = getFabrics(initialState);
    const mapStateToProps = state => (
        {
            fabrics,
            fabricInfoPrefix: getMessage(state, 'FABRIC_INFO_TITLE'),
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Fabrics);



// WEBPACK FOOTER //
// ./src/components/Fabrics.js